module.exports = __webpack_public_path__ + "img/latvia.35b79a6a.png";